<template>
  <div id="mySidenav" class="sidenav">
    <div class="sidenav-header mb-2">
      <span class="closebtn" @click.prevent="closeSideMenu"><i class="bi bi-x-lg"></i></span>
      <span class="imagelogo">
        <img :src="logoSrc" alt="maybets logo" />
      </span>
    </div>

    <div class="sidemenu-content">
      <div class="menu-items-wrapper">
        <div class="games-menu">
          <div class="overlay-menu-wrap">
            <div class="overlay-menu-nav-item">
              <button
                aria-pressed="true"
                aria-describedby="a11y__link-button--prematch"
                aria-label="Prematch icon"
                class="overlay-menu__nav__button"
                @click="goHome"
              >
                <svg
                  width="20px"
                  height="20px"
                  viewBox="0 0 64 64"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  aria-hidden="true"
                  role="img"
                  class="iconify iconify--emojione-monotone"
                  preserveAspectRatio="xMidYMid meet"
                  fill="#000000"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <path
                      d="M61.934 31.992c.021-.713.209-10.904-5.822-17.538c-.268-.593-1.539-2.983-5.641-5.904a41.959 41.959 0 0 0-5.775-3.763l-.008-.004C44.432 4.646 39.43 2 33.359 2c-.461 0-.917.027-1.368.058V2.05c-4.629-.101-9.227 1.09-11.998 2.341c-2.458 1.11-5.187 2.971-5.384 3.115C11.205 9.41 4.75 17.051 4.239 21.1c-2.063 2.637-3.787 14.482.004 21.697c2.658 10.027 12.664 15.045 13.46 15.43c.484.309 5.937 3.68 12.636 3.68c.281 0 1.98.094 2.586.094c7.241 0 17.971-5.104 20.217-9.102c6.171-4.514 9.37-16.147 8.792-20.907M17.758 47.055c-2.869-4.641-4.504-10.705-4.854-12.098c.908-1.361 5.387-7.965 7.939-9.952c1.445.266 7.479 1.374 13.17 2.404c.715 1.853 3.852 10.029 4.75 13.185c-.99 1.174-4.879 5.702-8.708 9.248c-4.065.019-10.979-2.326-12.297-2.787M53.824 14.58c-.012.45-.119 2.05-.885 3.887c-1.521-.777-5.344-2.441-10.584-2.722c-.793-1.171-3.777-5.254-8.49-8.086c.645-1.262 1.543-2.801 2.068-3.27c.17-.048.434-.092.836-.092c2.527 0 6.893 1.655 7.273 1.802c.403.213 8.251 4.439 9.782 8.481M11.773 34.012c-3.423-.584-5.458-1.648-6.066-2.008c-1.273-4.617-.248-9.607-.09-10.322c1.256-2.246 4.832-7.971 7.191-9.058c2.445-.499 5.494.121 6.736.424c-.117 1.615-.342 6.127.326 10.862c-2.706 2.178-6.989 8.447-8.097 10.102M31.685 3.53c.768.057 1.895.225 2.667.454c-.77 1.024-1.559 2.542-1.932 3.292c-1.57.257-7.533 1.397-12.211 4.43c-.943-.25-3.791-.917-6.488-.687c.668-1.293 1.666-2.249 1.773-2.347c.371-.266 7.513-5.263 16.191-5.155v.013m19.096 38.093c-1.17-.048-5.678-.305-10.621-1.466c-.947-3.302-4.074-11.444-4.789-13.296a556.586 556.586 0 0 1 6.928-9.654c5.688.312 9.682 2.387 10.455 2.82c3.295 5.299 4.018 10.711 4.117 11.615c-1.75 5.446-5.211 9.113-6.09 9.981M3.655 28.519c.084 1.266.287 2.599.654 3.917a11.738 11.738 0 0 0-.682 2.651a33.039 33.039 0 0 1 .028-6.568m9.644 23.359c1.508-1.453 3.367-2.867 4.088-3.401c1.63.574 8.324 2.837 12.591 2.837c.727.975 3.104 4.028 6.018 6.362c-1.814 1.775-4.434 2.613-4.897 2.752c-8.127.218-16.042-4.35-17.8-8.55m21.463 8.538c.922-.537 1.883-1.244 2.678-2.139c1.297-.179 6.863-1.137 11.893-4.832c.332.036.879.08 1.49.063c-3.018 2.957-10.382 6.26-16.061 6.908m15.424-8.376c1.807-4.708 1.73-8.258 1.641-9.392c.992-.972 4.396-4.599 6.285-10.113c1.018.17 1.68.429 1.994.574c.109.4.291 1.324.188 2.725c-.77 5.043-3.428 12.6-8.084 15.941c-.468.239-1.292.291-2.024.265"
                      fill="var(--color-fg)"
                    ></path>
                  </g>
                </svg>
                <span>Sports</span>
              </button>
            </div>

            <div class="overlay-menu-nav-item">
              <button
                aria-pressed="true"
                aria-describedby="a11y__link-button--casino"
                aria-label="Aviator icon"
                class="overlay-menu__nav__button"
                @click="goToAvi"
              >
                <svg
                  id="aviator"
                  data-name="Layer 1"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 400.47 352.46"
                  class="overlay-menu__nav__icon"
                >
                  <path
                    d="M412.3,334.53l-11.81,46.93a17.88,17.88,0,0,1-6.66,9.67,17.59,17.59,0,0,1-10.95,4l15.28-60.65h-18.9l-2,9.2-15.15,60.65h18.38q13.45,0,25.57-9.95T421.55,371l6.83-27.31,2.31-9.2H412.3Z"
                    transform="translate(-279.25 -104.08)"
                    class="cls-1"
                  ></path>
                  <path
                    d="M446,388.32a5,5,0,0,1,.18-0.69,4.45,4.45,0,0,0,.17-0.55l13.15-52.54H429l-2.32,9.2h12.19L428,387.07a8.46,8.46,0,0,0-.4,1.66q-1.18,7.13,3.63,11.32t14.27,4.18h2.74l2.34-9.2C446.88,394.5,445.36,392.25,446,388.32Zm17.24-82.45a7.62,7.62,0,0,0-6.14-2.75,10.58,10.58,0,0,0-7,2.75,10.83,10.83,0,0,0-3.81,6.58,7.9,7.9,0,0,0,1.65,6.72,7.56,7.56,0,0,0,6.12,2.75,10.47,10.47,0,0,0,7.06-2.81,11.11,11.11,0,0,0,3.83-6.66A7.85,7.85,0,0,0,463.24,305.87Z"
                    transform="translate(-279.25 -104.08)"
                    class="cls-1"
                  ></path>
                  <path
                    d="M513.78,390a2.53,2.53,0,0,1,.17-0.55,2.34,2.34,0,0,0,.15-0.54l13.58-54.34H496a33,33,0,0,0-18.41,5.57Q469.05,345.65,467,354l-7.66,30.74a9.09,9.09,0,0,0-.42,1.78,13,13,0,0,0,4.49,12.69q5.77,5,15.1,5h2.88a23.48,23.48,0,0,0,15.05-5.63q3.48,5.63,13.07,5.63H516l2.32-9.2Q513,394.76,513.78,390Zm-17.11-5.21a13.59,13.59,0,0,1-4.89,7.27,12.69,12.69,0,0,1-8,3c-5.3,0-7.53-2.55-6.7-7.69,0-.08.08-0.31,0.18-0.68a7.55,7.55,0,0,0,.2-0.83l8.81-35.26q1.8-6.85,7.57-6.86H507Z"
                    transform="translate(-279.25 -104.08)"
                    class="cls-1"
                  ></path>
                  <path
                    d="M617,339.54q-5.7-5-15-5h-2.88a32.61,32.61,0,0,0-18.56,5.63q-8.4,5.63-10.43,13.85l-7.8,30.74a10.41,10.41,0,0,0-.42,1.78q-1.29,7.82,4.49,12.76t15.24,4.94h2.74a32.59,32.59,0,0,0,18.5-5.69q8.49-5.7,10.5-13.79L621.11,354l0.29-1.77A13.09,13.09,0,0,0,617,339.54Zm-14,13L602.72,354l-7.64,30.74a15.49,15.49,0,0,1-4,7.61A8.29,8.29,0,0,1,585.3,395a4.59,4.59,0,0,1-4.2-2.48,9.25,9.25,0,0,1-.82-6.3,5.07,5.07,0,0,1,.2-0.75,7.16,7.16,0,0,0,.18-0.75L588.31,354a16.36,16.36,0,0,1,3.81-7.33,8,8,0,0,1,6-2.81,4.58,4.58,0,0,1,4.15,2.26C603.17,347.64,603.43,349.77,603,352.5Z"
                    transform="translate(-279.25 -104.08)"
                    class="cls-1"
                  ></path>
                  <path
                    d="M673.56,334.53a31.74,31.74,0,0,0-19.22,5.9l1.38-5.9h-18.3l-17.56,69.7h18.39l9.55-38.13A32.06,32.06,0,0,1,655,353a28.19,28.19,0,0,1,12-8.44l-2.18,9.06h10l4.9-19.08h-6.17Z"
                    transform="translate(-279.25 -104.08)"
                    class="cls-1"
                  ></path>
                  <path
                    d="M364.66,308.32q-6.3-5.19-17-5.21a36.78,36.78,0,0,0-20.57,5.83,25.29,25.29,0,0,0-11.3,15.45l-7.64,30.3c-6.45,0-12.43,0-17.07,0a11.87,11.87,0,0,0-11.84,11.93h25.89l-9.44,37.58h18.23l9.47-37.58H340L334.12,390a8.83,8.83,0,0,0-.41,1.78c-0.65,3.94.12,7,2.34,9.2s5.53,3.28,10,3.28h7.28l2.34-9.2c-2.63-.18-3.73-1.6-3.28-4.23L369,324.39a8.5,8.5,0,0,1,.24-1.1,9.52,9.52,0,0,0,.24-1.12Q370.93,313.56,364.66,308.32ZM326.28,354.9l0-.21,8.43-32.91a12.63,12.63,0,0,1,3.91-6.81,9.81,9.81,0,0,1,6.69-2.66,5.85,5.85,0,0,1,5.12,2.34,7.72,7.72,0,0,1,1.1,5.89l-0.21,1.24-8.43,32.91-0.06.21H326.28Z"
                    transform="translate(-279.25 -104.08)"
                    class="cls-1"
                  ></path>
                  <path
                    d="M561.79,334.53L566,318.35H547.57l-4,16.18h-9l-2.34,9.2h9l-11,43.49q0,0.28-.23,1a9.41,9.41,0,0,0-.22,1q-1.15,7,2.71,11t11.69,4h6.46L553,394.9q-5.67-.53-4.7-6.44a4.61,4.61,0,0,1,.18-0.69c0.08-.28.14-0.45,0.15-0.55l11-43.49h7.83l2.34-9.2h-8Z"
                    transform="translate(-279.25 -104.08)"
                    class="cls-1"
                  ></path>
                  <polygon
                    points="266.98 106.33 226.47 98.47 266.97 82.2 274.91 91.43 266.98 106.33"
                    class="cls-1"
                  ></polygon>
                  <path
                    d="M359.48,283v0l0.06,0h-0.06Z"
                    transform="translate(-279.25 -104.08)"
                    class="cls-1"
                  ></path>
                  <path
                    d="M599.74,189.58c-4.84-10.59-8.39-19.64-9.66-21.81-3.7-6.26-9.21-5.92-13.94-5.1-12.61,2.17-17.53,4.39-39.76,10.3-3.27.9-9.44,2.71-12.84,1.53-9-3.08-11.73-5.55-16.05-5.06-6.69.77-20.44,7.23-35.37,18.14-4.67,3.36-4.13,7.38-5,10a0.94,0.94,0,0,0,.8,1.21c2.17,0.22,25.86,2.28,26.94,2.43a1,1,0,0,1-.54-0.88,0.87,0.87,0,0,1,.49-0.8c6.76-3.64,31.32-16.65,46.15-22.5,20.29-8.05,25.19-8.91,31.35-9.49a36.38,36.38,0,0,1,4.93.06,3,3,0,0,1,2.62,1.93c2.8,8.22,11,26.79,15.34,32.94A3,3,0,0,1,593,204c-1.14,0-3.46-2.13-4.9-3.4a1,1,0,0,0-1.14-.07c-24.33,15-41.87,21.54-44.4,22.44a0.83,0.83,0,0,1-.64,0l-12.43-4.63a10.54,10.54,0,0,0,1.63-2.71,3.81,3.81,0,0,0,.35-1.55c-0.09-2-2-2.43-2.86-2.54-3.31-.41-92.12-13.51-114.39-15.7-9.45-1-18.44,3.89-22.33,9l0,0.13,12.61,13.14a0.92,0.92,0,0,0,1.07.21l9.92-4.57s1.36,4.2.09,4.91c-8.24,4.52-16.22,8.56-23.94,12.61-3.1,1.64-3,4.74-4,9.1-0.42,1.82-.64,3.49-0.64,3.49s17.3-8.67,27.9-13.73a1,1,0,0,1,1.08.21c1.51,1.63,2,2,3,3a0.94,0.94,0,0,1-.22,1.49c-2.5,1.33-5.08,2.69-7.06,3.87-1.57.93,0,4.06,0,4.06l28.79-13.64s1.79,1.77-1.38,3.74c-4.91,3.08-50.32,26.23-54.22,26.33-10.3.26-29.73-19.12-36.75-22.07-5.92-2.49-12.3,1.57-20.95,6.65-2.35,1.4-.92,4.78-0.92,4.78l12.54-6.35s1.55,1.79-.19,2.88c-6.07,3.85-14.85,7.7-16.2,8.67-2,1.42-1.22,8.07-1.22,8.07l11.86-5.5a1,1,0,0,1,1,.06l25.42,24.2a28.49,28.49,0,0,0,4.71-1.59l-21.21-22.55a1,1,0,0,1,.26-1.49c2.17-1.1,4.76-1.91,8.43.9,3.08,2.34,13.86,11.06,24.29,10.13,3.48-.3,3.53.77,3.53,0.77s-4.43,2.13-9.68,5c-2.6,1.44-.49,5.23-0.49,5.23,26.87-11,60-24.74,64.6-26.74a1,1,0,0,1,1,.13l7.77,6.17c1.1,1.72,56.37-19.53,73.41-28.14,1-.47,9.62-0.07,13.81-0.11,1.92,0,1.85.84,1.85,0.84S393.47,284.26,359.54,283l-0.06,0-7.23,3.1c4.24,2.8,3.23,7.64,10.45,3.9,0.43,1,.93,2,1.46,3.16,1.4,3,1.4,3.06,10.58-.06,26-8.78,142.68-43.67,168.82-54.49,14.76-6.09,35.17-14.5,47.89-22.38C604,208.51,606.56,204.51,599.74,189.58Zm-111.67.54c-1.57,1.12-11.91-.81-11.91-0.81s11.44-10.17,22.33-11.47c3.24-.39,9.79,2.15,9.79,2.15S493.67,186.09,488.07,190.12ZM522.77,180L508,187.58s-3.42-2.07.43-3.81c1-.45,3.25-1.74,5.08-2.69a1.34,1.34,0,0,0-.13-2.43l-10.95-4.39a8.42,8.42,0,0,1,7.47-1.53c1.59,0.49,8.24,3.29,12.61,5.12A1.15,1.15,0,0,1,522.77,180Zm3.68,35.73c-1.44,2.13-4.8,6.09-9.74,5.29-2.41-.41-100.49-20.31-100.73-20.33-0.69-.19-0.6-1.66.65-1.51L525.8,214.26A1,1,0,0,1,526.45,215.76Z"
                    transform="translate(-279.25 -104.08)"
                    class="cls-1"
                  ></path>
                  <path
                    d="M597.33,171a1.77,1.77,0,0,0-.3.07,0.78,0.78,0,0,0-.26.17l1-.26Z"
                    transform="translate(-279.25 -104.08)"
                    class="cls-1"
                  ></path>
                  <path
                    d="M637.65,244.74c-0.82-3.29-6.84-25.09-10.31-33.09l-15.85-28.44a45.11,45.11,0,0,1-5,5.81,5,5,0,0,1-1,.67A4.12,4.12,0,0,1,604,190l8.54,28c1.27,4.5,4.24,8.33,6.8,12.22,1.29,1.92,10.37,15.47,13.86,20.67a1.84,1.84,0,0,0,3.06,0A8.17,8.17,0,0,0,637.65,244.74Zm-3.1,3.89-0.19.3-0.21-.3c-0.13-.19-12.95-19.06-17.58-26.37-1.4-2.2.24-3.31,0.24-3.31l0.19-.11,0.13,0.17c0.65,0.82,15.77,20.52,17.73,24.14A5.56,5.56,0,0,1,634.55,248.63Z"
                    transform="translate(-279.25 -104.08)"
                    class="cls-1"
                  ></path>
                  <path
                    d="M595.59,139.36c-1.74-5.89-4.71-9.7-7.29-13.6-1.29-2-10.73-16-14.05-21a1.57,1.57,0,0,0-2.62,0,8.68,8.68,0,0,0-1.44,6.65c0.84,3.27,6.65,25,10.13,33l14.46,25.47a3.94,3.94,0,0,1,1.31-1,3.29,3.29,0,0,1,1.08-.26c1.91-.13,4.9-0.11,7.6-0.06Zm-4.67-2-0.19.11-0.13-.17c-0.64-.84-15.73-20.52-17.73-24.16a5.63,5.63,0,0,1,.34-5.47l0.19-.28,0.21,0.28c0.13,0.21,13,19.1,17.58,26.38C592.58,136.29,590.94,137.37,590.92,137.39Z"
                    transform="translate(-279.25 -104.08)"
                    class="cls-1"
                  ></path>
                  <path
                    d="M613.53,171c-3.94-.88-11.4-0.93-15.86-0.65a4.14,4.14,0,0,0-.49,0,2.62,2.62,0,0,0-.32.07,0.82,0.82,0,0,0-.28.19,1.53,1.53,0,0,0-.6,1.66c2.24,5.66,4.22,10.05,6.82,15.21a1.59,1.59,0,0,0,2,.5,2.16,2.16,0,0,0,.41-0.26,44.45,44.45,0,0,0,9.66-13.57C615.6,172.58,615.17,171.34,613.53,171Zm-12.95,7.66-2.28-5.25a0.85,0.85,0,0,1,.52-1.2,1,1,0,0,1,.24-0.09s9.44-.34,12.39.24c1.57,0.32,1.63.88,1.63,0.88Z"
                    transform="translate(-279.25 -104.08)"
                    class="cls-1"
                  ></path>
                  <path
                    d="M565.47,172.43s-1.78,7.37-4.59,15.87l-5.2-6.57-4.21,1.92,7.66,9.7c-2.39,6.54-5.27,13.05-8.34,16.89l7.68-3.49c1.75-1.62,3.16-4.9,4.26-8.84l4.22,5.34,4.24-1.93-7.16-9C565.59,184.11,566,175.22,565.47,172.43Z"
                    transform="translate(-279.25 -104.08)"
                    class="cls-1"
                  ></path>
                  <rect
                    x="140.27"
                    y="322.79"
                    width="119.94"
                    height="10"
                    rx="5"
                    ry="5"
                    class="cls-1"
                  ></rect>
                  <rect
                    x="160.27"
                    y="342.46"
                    width="79.94"
                    height="10"
                    rx="5"
                    ry="5"
                    class="cls-1"
                  ></rect>
                </svg>
                <span>Aviator</span>
              </button>
            </div>

            <div class="overlay-menu-nav-item d-none">
              <button
                aria-pressed="true"
                aria-describedby="a11y__link-button--shikisha-bet"
                aria-label="Shikisha Bet icon"
                class="overlay-menu__nav__button"
                @click="goToAviatorMiles"
              >
                <svg
                  fill="var(--color-fg)"
                  width="20px"
                  height="20px"
                  viewBox="0 0 1920 1920"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <path
                      d="M211.733 1260.088c16.32 131.947 68.587 258.027 151.254 364.8l-168.64 130.667C88.213 1618.488 21.013 1456.14 0 1286.22Zm1654.155-391.584c18.88 57.813 32.32 117.76 39.787 178.24 4.8 40 7.146 79.147 7.146 119.787 0 40.533-2.346 79.68-7.146 119.466-21.014 170.134-88.214 332.48-194.347 469.547l-168.64-130.667c82.667-106.773 134.933-232.853 151.253-364.8 3.734-30.72 5.547-61.76 5.547-93.546 0-31.894-1.813-62.934-5.547-93.867-5.866-46.613-16.106-93.013-30.72-137.813Zm-135.125-421.707 150.826 150.827-875.413 875.413-519.893-519.893 150.826-150.827 369.067 369.067 724.587-724.587ZM194.347 577.411l168.64 130.666c-82.667 106.774-134.934 232.854-151.254 364.8L0 1046.744c21.013-169.92 88.213-332.267 194.347-469.333ZM833.14 213.709l26.134 211.734c-132.054 16.213-258.134 68.586-364.8 151.253L363.7 408.056c137.067-106.133 299.307-173.44 469.44-194.347Zm239.456-.01c170.027 21.013 332.374 88.213 469.334 194.346l-130.774 168.64c-106.56-82.666-232.746-135.04-364.693-151.253Z"
                      fill-rule="evenodd"
                    ></path>
                  </g>
                </svg>
                <span>Aviator Miles</span>
                <span
                  style="
                    background-color: orangered;
                    color: white;
                    padding: 2px 8px;
                    border-radius: 12px;
                    font-size: 10px;
                    font-weight: bold;
                    margin-left: -12px;
                  "
                >
                  New
                </span>
              </button>
            </div>

            <div class="overlay-menu-nav-item">
              <button
                aria-pressed="true"
                aria-describedby="a11y__link-button--live-games"
                aria-label="Live Games icon"
                class="overlay-menu__nav__button"
                @click="goToLigi"
              >
                <svg
                  id="Capa_1"
                  fill="var(--color-fg)"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="20px"
                  height="20px"
                  viewBox="0 0 310.055 310.055"
                  xml:space="preserve"
                  stroke="var(--color-fg)"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <g>
                      <g>
                        <path
                          d="M303.938,1.066c-2.854-1.66-59.947-5-66.606,22.9c-6.659,27.897-14.426,55.139-39.965,44.11 c-15.7-6.781,0-48.219,0-48.219s-18.921,26.416-40.909,30.064c-27.312,4.528,0-25.956,0-25.956 c-54.806,7.767-78.858,41.963-89.292,67.302c-3.348,1.815-6.597,3.783-9.729,5.898c-3.097,2.089-6.09,4.326-8.963,6.7 c-1.437,1.188-2.845,2.408-4.22,3.658c-2.757,2.504-5.393,5.14-7.894,7.896c-1.253,1.378-2.473,2.784-3.658,4.221 c-2.372,2.874-4.609,5.864-6.703,8.96c-4.184,6.193-7.786,12.806-10.732,19.768c-1.476,3.48-2.778,7.05-3.915,10.695 c-1.134,3.646-2.094,7.369-2.869,11.159c-1.548,7.57-2.364,15.415-2.364,23.452c0,3.35,0.176,6.664,0.451,9.947 c0.031,0.362,0.049,0.725,0.085,1.087c0.303,3.169,0.738,6.302,1.29,9.394c0.067,0.389,0.132,0.771,0.205,1.16 c0.59,3.122,1.294,6.203,2.128,9.232c0.067,0.264,0.147,0.518,0.217,0.776c0.891,3.153,1.888,6.261,3.032,9.3l0,0l-0.026,0.777 l0.632,0.761l0,0c2.115,5.406,4.626,10.61,7.49,15.586c0.005,0.011,0.016,0.026,0.023,0.036c2.845,4.94,6.048,9.647,9.569,14.101 c0.044,0.052,0.085,0.108,0.127,0.16c3.485,4.386,7.28,8.513,11.348,12.35c0.106,0.099,0.208,0.197,0.313,0.301 c2.03,1.9,4.129,3.733,6.294,5.488c0.036,0.036,0.081,0.067,0.122,0.099c2.084,1.678,4.226,3.288,6.426,4.826 c0.186,0.124,0.365,0.264,0.551,0.389c2.206,1.527,4.472,2.982,6.783,4.354c0.249,0.15,0.508,0.29,0.756,0.435 c2.149,1.259,4.339,2.439,6.571,3.558c0.254,0.13,0.502,0.259,0.753,0.389c2.348,1.154,4.751,2.227,7.185,3.226 c0.43,0.171,0.856,0.337,1.292,0.508c2.245,0.885,4.513,1.714,6.82,2.459c0.277,0.089,0.546,0.192,0.823,0.275 c2.48,0.786,5,1.476,7.55,2.097c0.557,0.135,1.118,0.259,1.675,0.389c2.403,0.543,4.832,1.03,7.291,1.424 c0.212,0.031,0.419,0.077,0.632,0.108c2.602,0.404,5.248,0.699,7.909,0.927c0.637,0.052,1.274,0.099,1.911,0.14 c2.698,0.187,5.414,0.321,8.155,0.321c30.126,0,57.591-11.448,78.252-30.235c2.755-2.501,5.396-5.137,7.892-7.896 c0.942-1.035,1.844-2.092,2.739-3.158c20.169-10.568,36.169-22.437,36.708-28.169c1.258-13.318-1.129-40.068,19.677-56.136 c20.806-16.062,16.176-58.045,16.176-58.045c-24.741,41.863-52.33-14.271-25.688-19.254c26.646-4.979,25.688-30.222,10.465-57.25 C253.508,22.89,303.938,1.066,303.938,1.066z M194.922,276.657c-19.396,16.953-44.684,27.33-72.416,27.33 c-29.743,0-56.752-11.848-76.61-31.048l21.406-18.403l-20.435-52.667L14.892,190.86l-0.735,23.488 c-1.279-6.706-1.973-13.613-1.973-20.682c0-14.7,2.91-28.728,8.156-41.567l27.524-34.157l7.138-11.443 c2.814-2.183,5.773-4.189,8.795-6.103c17.015-10.758,37.122-17.052,58.704-17.052c0.608,0,1.214,0.036,1.817,0.047l12.319,4.533 l27.144,3.467c17.378,7.042,32.57,18.369,44.242,32.689l-4.516,19.682l17.833,50.288l11.382,2.889 C231.801,228.728,217.297,257.088,194.922,276.657z"
                        ></path>
                        <polygon
                          points="164.931,131.006 126.975,95.596 85.128,110.651 73.951,114.669 75.712,164.638 95.474,168.398 133.735,175.663 "
                        ></polygon>
                        <polygon
                          points="119.123,259.828 113.522,266.125 142.077,295.877 161.099,287.753 191.939,274.57 200.09,230.503 150.587,224.415 "
                        ></polygon>
                      </g>
                    </g>
                  </g>
                </svg>
                <span>Ligi Soo</span>
                <span
                  style="
                    background-color: mediumpurple;
                    color: white;
                    padding: 2px 8px;
                    border-radius: 12px;
                    font-size: 10px;
                    font-weight: bold;
                    margin-left: -12px;
                  "
                >
                  Bonus
                </span>
              </button>
            </div>

            <div class="overlay-menu-nav-item d-none">
              <button
                aria-pressed="true"
                aria-describedby="a11y__link-button--live-games"
                aria-label="Live Games icon"
                class="overlay-menu__nav__button"
                @click="goToLive"
              >
                <svg
                  viewBox="0 0 20 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="overlay-menu__nav__icon"
                >
                  <path
                    d="M16.0511 2.04823C14.6603 1.91205 12.4816 1.74974 9.99987 1.74974C7.51819 1.74974 5.3394 1.91201 3.94863 2.04823C2.86401 2.1544 1.99997 2.98109 1.84739 4.05861C1.65816 5.39473 1.56222 6.72073 1.56222 7.99989C1.56222 9.27906 1.65816 10.605 1.84739 11.9411C1.99997 13.0187 2.86401 13.8454 3.94863 13.9516C5.33944 14.0877 7.51819 14.25 9.99987 14.25C12.4816 14.25 14.6603 14.0878 16.0511 13.9516C17.1357 13.8454 17.9998 13.0187 18.1524 11.9412C18.2129 11.5139 18.6083 11.2166 19.0354 11.2771C19.4627 11.3376 19.7599 11.733 19.6995 12.1602C19.4454 13.9539 18.0078 15.33 16.2033 15.5067C14.7779 15.6462 12.5446 15.8125 9.99983 15.8125C7.45506 15.8125 5.22178 15.6462 3.79637 15.5067C1.99188 15.3301 0.554238 13.9539 0.30021 12.1602C-0.10007 9.31917 -0.10007 6.68061 0.30021 3.83955C0.554238 2.04588 1.99188 0.669725 3.79637 0.493121C5.22174 0.353587 7.45506 0.187256 9.99983 0.187256C12.5446 0.187256 14.7779 0.353587 16.2033 0.493121C18.0078 0.669725 19.4454 2.04588 19.6995 3.83959C19.8989 5.24801 20 6.64772 20 7.99989C19.9592 9.03546 18.4788 9.03667 18.4375 7.99989C18.4375 6.72077 18.3415 5.39477 18.1523 4.05869C17.9998 2.98109 17.1357 2.1544 16.0511 2.04823V2.04823ZM13.0276 6.74471C14.0374 7.30863 14.0372 8.82803 13.0276 9.39175L9.67385 11.3378C9.19669 11.6147 8.62641 11.6157 8.14843 11.3403C7.66893 11.0642 7.38264 10.5685 7.38264 10.0143V6.12213C7.38264 5.56794 7.66893 5.07226 8.14843 4.79613C8.62641 4.52081 9.19669 4.52182 9.67385 4.79863L13.0276 6.74471ZM12.1951 8.06825L8.94517 6.1824V9.95418L12.1951 8.06825Z"
                  ></path>
                </svg>
                <span>Live Games</span>
              </button>
            </div>

            <div class="overlay-menu-nav-item">
              <button
                aria-pressed="true"
                aria-describedby="a11y__link-button--casino"
                aria-label="Crash Games icon"
                class="overlay-menu__nav__button"
                @click="goToCrash"
              >
                <svg
                  id="Icons"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 32 32"
                  xml:space="preserve"
                  width="20px"
                  height="20px"
                  fill="#000000"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <path
                      style="fill: var(--color-fg)"
                      d="M29,2.9c0-0.1,0-0.2,0-0.3c0,0,0-0.1,0-0.1c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0-0.1c0,0,0,0,0,0c0,0,0,0,0,0 c-0.1-0.1-0.2-0.1-0.3-0.2c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3-0.1c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0 l-25,12C2.3,14.3,2,14.6,2,14.9s0.1,0.7,0.4,0.9l5.2,3.9l6.8-5.5c0.4-0.3,1.1-0.3,1.4,0.2c0.3,0.4,0.3,1.1-0.2,1.4L9,21.1V29 c0,0.4,0.3,0.8,0.7,0.9C9.8,30,9.9,30,10,30c0.3,0,0.6-0.1,0.8-0.4l3.7-4.8l3.9,2.9c0.2,0.1,0.4,0.2,0.6,0.2c0.1,0,0.2,0,0.3,0 c0.3-0.1,0.5-0.3,0.7-0.6l9-24C29,3.2,29,3.1,29,2.9C29,3,29,3,29,2.9z"
                    ></path>
                  </g>
                </svg>
                <span>Crash Games</span>
              </button>
            </div>

            <div class="overlay-menu-nav-item">
              <button
                aria-pressed="true"
                aria-describedby="a11y__link-button--casino"
                aria-label="Casino icon"
                class="overlay-menu__nav__button"
                @click="goToCasino"
              >
                <svg
                  id="crashgames"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 25 24"
                  fill="none"
                  class="overlay-menu__nav__icon"
                >
                  <path
                    d="M20.8659 1.96681L15.1799 0.22081C13.9248 -0.161429 12.5699 -0.0361962 11.4062 0.56961C10.2424 1.17542 9.36267 2.21347 8.9559 3.46081L8.7679 3.99981H5.3999C4.07431 4.00139 2.80346 4.52869 1.86612 5.46602C0.928784 6.40336 0.40149 7.67421 0.399902 8.9998L0.399902 18.9998C0.40149 20.3254 0.928784 21.5962 1.86612 22.5336C2.80346 23.4709 4.07431 23.9982 5.3999 23.9998H11.3999C12.1574 23.9971 12.9043 23.8215 13.5837 23.4864C14.263 23.1512 14.8569 22.6653 15.3199 22.0658C15.5481 22.0989 15.7783 22.1163 16.0089 22.1178C17.0827 22.1186 18.128 21.7721 18.9886 21.1299C19.8492 20.4877 20.479 19.5844 20.7839 18.5548L24.1999 8.1558C24.5648 6.8931 24.4201 5.53765 23.7967 4.38049C23.1734 3.22333 22.1211 2.35675 20.8659 1.96681ZM11.3999 21.9998H5.3999C4.60425 21.9998 3.84119 21.6837 3.27858 21.1211C2.71597 20.5585 2.3999 19.7954 2.3999 18.9998V8.9998C2.3999 8.20415 2.71597 7.44109 3.27858 6.87848C3.84119 6.31587 4.60425 5.9998 5.3999 5.9998H11.3999C12.1956 5.9998 12.9586 6.31587 13.5212 6.87848C14.0838 7.44109 14.3999 8.20415 14.3999 8.9998V18.9998C14.3999 19.7954 14.0838 20.5585 13.5212 21.1211C12.9586 21.6837 12.1956 21.9998 11.3999 21.9998ZM22.2869 7.5628L18.8749 17.9628C18.7054 18.5381 18.3668 19.0492 17.9032 19.4297C17.4395 19.8103 16.8723 20.0427 16.2749 20.0968C16.357 19.7369 16.3989 19.3689 16.3999 18.9998V8.9998C16.3983 7.67421 15.871 6.40336 14.9337 5.46602C13.9963 4.52869 12.7255 4.00139 11.3999 3.99981H10.8929C11.151 3.27238 11.6796 2.67244 12.3687 2.32472C13.0578 1.977 13.8544 1.90827 14.5929 2.13281L20.2789 3.87881C21.0278 4.1099 21.6569 4.62436 22.0319 5.31253C22.407 6.0007 22.4985 6.80816 22.2869 7.5628ZM12.3999 12.9998C12.3999 14.4498 10.8559 16.3908 9.6859 17.3778C9.32643 17.6819 8.87078 17.8488 8.3999 17.8488C7.92902 17.8488 7.47338 17.6819 7.1139 17.3778C5.9439 16.3908 4.3999 14.4498 4.3999 12.9998C4.3999 12.4694 4.61062 11.9607 4.98569 11.5856C5.36076 11.2105 5.86947 10.9998 6.3999 10.9998C6.93034 10.9998 7.43904 11.2105 7.81412 11.5856C8.18919 11.9607 8.3999 12.4694 8.3999 12.9998C8.3999 12.4694 8.61062 11.9607 8.98569 11.5856C9.36076 11.2105 9.86947 10.9998 10.3999 10.9998C10.9303 10.9998 11.439 11.2105 11.8141 11.5856C12.1892 11.9607 12.3999 12.4694 12.3999 12.9998Z"
                    style="fill: var(--color-fg)"
                  ></path>
                </svg>
                <span>Casino</span>
              </button>
            </div>

            <div class="overlay-menu-nav-item">
              <button
                aria-pressed="true"
                aria-describedby="a11y__link-button--casino"
                aria-label="Crash Games icon"
                class="overlay-menu__nav__button"
                @click="goToVirt"
              >
                <svg
                  version="1.0"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20px"
                  height="20px"
                  viewBox="0 0 67.000000 67.000000"
                  preserveAspectRatio="xMidYMid meet"
                >
                  <g
                    transform="translate(0.000000,67.000000) scale(0.100000,-0.100000)"
                    fill="var(--color-fg)"
                    stroke="none"
                  >
                    <path
                      d="M21 646 c-8 -9 -11 -101 -9 -317 l3 -304 318 -3 317 -2 0 314 c0 277
                    -2 315 -16 320 -9 3 -147 6 -309 6 -235 0 -295 -3 -304 -14z m607 -18 c19 -19
                    17 -571 -2 -587 -9 -8 -97 -11 -302 -9 l-289 3 -3 290 c-1 159 0 295 3 302 6
                    18 575 19 593 1z"
                    />
                    <path
                      d="M123 538 c3 -7 36 -104 74 -215 l68 -203 66 0 67 0 43 127 c23 71 44
                    134 47 141 3 10 -10 12 -58 10 l-63 -3 -17 -60 -17 -60 -16 55 c-8 30 -20 74
                    -26 98 -6 23 -16 60 -21 82 l-11 40 -70 0 c-53 0 -69 -3 -66 -12z"
                    />
                    <path
                      d="M397 503 c-7 -27 -12 -51 -10 -55 2 -5 30 -8 63 -8 l58 0 16 47 c9
                    26 16 50 16 55 0 4 -29 8 -64 8 l-65 0 -14 -47z"
                    />
                  </g>
                </svg>
                <span>Virtuals</span>
              </button>
            </div>

            <!--            <div class="overlay-menu-nav-item">-->
            <!--              <button @click="goToJP" aria-pressed="true" aria-describedby="a11y__link-button&#45;&#45;casino" aria-label="Crash Games icon" class="overlay-menu__nav__button">-->
            <!--                <svg fill="var(&#45;&#45;color-fg)" width="20px" height="20px" viewBox="0 0 14 14" role="img" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">-->
            <!--                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier">-->
            <!--                  <path d="m 12.324082,8.1685 -0.05633,0.1972 -0.211224,0.063 -0.213551,0.066 0.211224,0.061 0.211225,0.063 0.06098,0.2113 0.06098,0.2088 0.06575,-0.2112 0.06343,-0.2135 0.19947,-0.054 c 0.108,-0.03 0.190163,-0.063 0.178408,-0.073 -0.0094,-0.01 -0.08914,-0.035 -0.173633,-0.059 -0.08682,-0.021 -0.168979,-0.047 -0.183061,-0.056 -0.01408,-0.01 -0.04922,-0.096 -0.07739,-0.1925 -0.02816,-0.094 -0.05633,-0.1831 -0.06576,-0.1925 -0.0095,-0.01 -0.04004,0.07 -0.07053,0.1808 z M 1.483429,7.2203 C 1.413019,7.462 1.415349,7.455 1.382531,7.4668 c -0.01641,0 -0.110327,0.033 -0.206572,0.061 L 1,7.5818 1.197143,7.6428 c 0.110326,0.035 0.206571,0.078 0.218326,0.096 0.0094,0.019 0.04224,0.1126 0.07041,0.2089 l 0.05167,0.1761 0.05865,-0.1925 c 0.03282,-0.1057 0.07041,-0.2018 0.07984,-0.2112 0.01176,-0.01 0.105673,-0.045 0.211224,-0.078 L 2.079753,7.5811 1.892039,7.5271 C 1.788814,7.4961 1.694896,7.4641 1.680814,7.4521 1.669054,7.4401 1.629144,7.3418 1.596324,7.2362 L 1.535094,7.0437 1.483424,7.2197 Z M 5.623551,5.9365 C 5.316082,6.0398 4.952286,6.3379 4.839633,6.582 l -0.05633,0.122 -0.335633,0 -0.335632,0 L 3.75767,6.9834 C 2.929181,7.6359 2.497303,8.0935 2.236854,8.6004 2.023303,9.0182 1.955221,9.4241 2.030283,9.849 l 0.02584,0.1526 1.037388,0.01 1.037388,0 0.02584,-0.1338 C 4.245879,9.4248 4.457106,8.9484 4.757596,8.5188 4.921922,8.2841 4.940657,8.2466 4.978249,8.0636 5.104984,7.4557 5.464126,6.7586 5.949882,6.1743 6.083718,6.0147 6.118861,5.9607 6.095351,5.9467 6.029591,5.9087 5.7198,5.9047 5.623555,5.9347 Z M 12.432082,4.918 c -0.06808,0.075 -0.347388,0.2089 -0.521021,0.2511 -0.201796,0.049 -0.699428,0.052 -0.941143,0 L 10.798612,5.1361 10.582735,5.3614 C 10.324612,5.629 10.148531,5.8285 9.967796,6.0655 l -0.133714,0.1737 0.206571,0.066 c 0.227633,0.075 0.504612,0.1337 0.661837,0.1431 l 0.103224,0.01 L 10.432612,6.74 C 9.730857,7.2681 9.12302,7.8148 8.939959,8.0801 c -0.08216,0.1197 -0.180735,0.596 -0.201796,0.988 -0.01641,0.2722 0.0023,0.8449 0.02816,0.9153 0.0094,0.026 0.255795,0.03 1.377673,0.03 1.288531,0 1.363592,0 1.347184,-0.042 C 11.41612,9.7812 11.333955,9.4926 11.301016,9.3095 11.249346,9.0044 11.265746,8.3543 11.336286,8.0586 11.531102,7.2207 11.993469,6.4509 12.753878,5.6975 L 13,5.4536 12.739429,5.1625 C 12.596286,5.0053 12.478857,4.8739 12.476531,4.8739 c -0.0023,0 -0.02339,0.021 -0.04445,0.045 z m -11.162204,0.8355 0,0.9739 0.455265,0 c 0.431877,0 0.457714,0 0.471796,-0.044 0.02351,-0.075 0.345061,-0.3615 0.485877,-0.4319 0.07273,-0.038 0.187715,-0.073 0.262898,-0.08 l 0.131388,-0.014 0,-0.6806 0,-0.6806 -0.194816,0.012 c -0.131388,0.01 -0.241715,0.033 -0.347388,0.075 -0.08449,0.033 -0.176082,0.061 -0.204122,0.061 -0.06098,0 -0.122082,-0.059 -0.122082,-0.1197 0,-0.042 -0.02106,-0.045 -0.469347,-0.045 l -0.469469,0 0,0.9741 z m 2.065346,-0.6806 0,1.3729 0.640776,0 0.638327,0 0.0469,-0.082 C 4.719877,6.2535 5.015595,5.9742 5.194003,5.8592 5.597717,5.5965 5.900411,5.5893 6.635105,5.8242 7.095146,5.9697 7.346289,6.026 7.616166,6.0448 l 0.229959,0.014 -0.396734,0.2981 c -0.852,0.6336 -1.488,1.1687 -1.891592,1.5889 -0.849551,0.8848 -1.227429,1.7062 -1.182857,2.5699 0.0094,0.1572 0.03049,0.3474 0.0469,0.4248 l 0.03049,0.1408 2.189755,0.01 c 1.750898,0 2.187306,0 2.178,-0.023 C 8.587801,10.5378 8.477474,9.9887 8.475148,9.3667 8.472848,7.8506 9.174576,6.3932 10.566332,5.0155 L 10.934781,4.6517 10.573311,4.248 C 10.373842,4.025 10.204862,3.8443 10.19776,3.8443 c -0.0071,0 -0.05865,0.038 -0.110326,0.084 C 9.95127,4.0456 9.653229,4.1841 9.402087,4.2475 9.219025,4.2945 9.132209,4.3015 8.744903,4.2995 8.155801,4.2995 7.975066,4.2645 6.949434,3.9662 5.989556,3.6845 5.569434,3.6634 5.060168,3.8653 4.961598,3.9053 4.855923,3.9383 4.82776,3.9383 4.75735,3.9383 4.672862,3.8443 4.672862,3.767 l 0,-0.063 -0.668939,0 -0.668938,0 0,1.3731 z M 5.801837,4.1834 c 0.05633,0.068 -0.0047,0.1127 -0.183061,0.1409 -0.08914,0.012 -0.227633,0.049 -0.30747,0.077 -0.154898,0.059 -0.215877,0.045 -0.215877,-0.044 0,-0.061 0.04922,-0.092 0.239387,-0.1549 0.204245,-0.066 0.420123,-0.075 0.467021,-0.019 z m 0.267551,6.4049 0,0.07 -0.612612,0.01 c -0.657184,0.01 -0.69,0 -0.654858,-0.1127 0.01408,-0.047 0.02584,-0.047 0.640653,-0.042 l 0.626694,0.01 0,0.07 z M 8.827061,3.0826 c -0.02816,0.1009 -0.06331,0.1948 -0.07984,0.2089 -0.01408,0.014 -0.09392,0.045 -0.178408,0.068 -0.234734,0.063 -0.237061,0.07 -0.01408,0.1314 l 0.204122,0.056 0.06343,0.2112 0.06588,0.2089 0.054,-0.1854 c 0.03049,-0.1032 0.06331,-0.1994 0.07506,-0.2112 0.01176,-0.014 0.110327,-0.052 0.215878,-0.084 L 9.425593,3.4254 9.249511,3.3734 C 9.153271,3.3454 9.059348,3.3144 9.040613,3.3054 9.021883,3.2954 8.981963,3.2045 8.953793,3.1012 8.923303,3.0003 8.895143,2.9134 8.890363,2.9087 c -0.0045,0 -0.03269,0.075 -0.06331,0.1737 z"></path></g></svg>-->
            <!--                <span>Jackpots</span>-->
            <!--              </button>-->
            <!--            </div>-->

            <div class="overlay-menu-nav-item">
              <button
                aria-pressed="true"
                aria-describedby="a11y__link-button--casino"
                aria-label="Crash Games icon"
                class="overlay-menu__nav__button"
                @click="goToCountries"
              >
                <svg
                  width="20px"
                  height="20px"
                  viewBox="0 0 24 24"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  fill="#fff"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <title>A-Z_sort_ascending_letters_line</title>
                    <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g id="Editor" transform="translate(-240.000000, -96.000000)">
                        <g
                          id="A-Z_sort_ascending_letters_line"
                          transform="translate(240.000000, 96.000000)"
                        >
                          <path
                            id="MingCute"
                            d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z"
                            fill-rule="nonzero"
                          ></path>
                          <path
                            id="形状"
                            d="M10.7586,13 C11.6994,13 12.1893533,14.0920038 11.6139222,14.7923977 L11.5364,14.8778 L7.41424,19 L11,19 C11.5523,19 12,19.4477 12,20 C12,20.51285 11.613973,20.9355092 11.1166239,20.9932725 L11,21 L5.24145,21 C4.30065,21 3.81071515,19.9079962 4.3861123,19.2076023 L4.46363,19.1222 L8.58581,15 L5.00003,15 C4.44774,15 4.00003,14.5523 4.00003,14 C4.00003,13.48715 4.38606566,13.0644908 4.8834079,13.0067275 L5.00003,13 L10.7586,13 Z M17,4 C17.5523,4 18,4.44772 18,5 L18,17.414 L19.1213,16.2927 C19.5119,15.9022 20.145,15.9022 20.5356,16.2927 C20.9261,16.6832 20.9261,17.3164 20.5356,17.7069 L17.7071,20.5354 C17.3166,20.9259 16.6834,20.9259 16.2929,20.5354 L13.4645,17.7069 C13.074,17.3164 13.074,16.6832 13.4645,16.2927 C13.855,15.9022 14.4882,15.9022 14.8787,16.2927 L16,17.414 L16,5 C16,4.44772 16.4477,4 17,4 Z M8.00003,3 C8.674326,3 9.28067533,3.39562382 9.55608491,4.00153967 L9.60994,4.13453 L11.9418,10.6637 C12.1275,11.1838 11.8565,11.756 11.3364,11.9417 C10.85345,12.1142286 10.3254908,11.8927974 10.1038503,11.443863 L10.0583,11.3363 L9.58102,10 L6.41903,10 L5.94177,11.3363 C5.75602,11.8564 5.1838,12.1275 4.66369,11.9417 C4.18073071,11.7692643 3.91252214,11.2635709 4.02540056,10.7757876 L4.05829,10.6637 L6.39012,4.13453 C6.63311,3.45416 7.27757,3 8.00003,3 Z M8.00003,5.57321 L7.13332,8 L8.86674,8 L8.00003,5.57321 Z"
                            fill="var(--color-fg)"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
                <span>A-Z Countries</span>
              </button>
            </div>

            <!--            <div class="overlay-menu-nav-item d-none">-->
            <!--              <button @click="goToBetB" aria-pressed="true" aria-describedby="a11y__link-button&#45;&#45;casino" aria-label="Crash Games icon" class="overlay-menu__nav__button">-->
            <!--                <svg viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="overlay-menu__nav__icon">-->
            <!--                  <path-->
            <!--                    d="M9.00811 10.8971C8.46182 10.8971 7.91597 10.7837 7.40961 10.5572L3.00587 8.72255C1.54491 8.11139 0.601562 6.69418 0.601562 5.11166V3.91374C0.601562 1.75568 2.35725 0 4.51527 0H13.4845C15.6425 0 17.3982 1.75568 17.3982 3.9137V5.11162C17.3982 6.69414 16.4549 8.11135 14.995 8.72208L10.5182 10.595C10.0365 10.7966 9.52212 10.8971 9.00811 10.8971ZM4.51527 1.56248C3.2188 1.56248 2.16404 2.61723 2.16404 3.9137V5.11162C2.16404 6.06235 2.73076 6.91375 3.60782 7.28066L8.02034 9.11896C8.0273 9.12185 8.03417 9.12485 8.04105 9.12794C8.63295 9.39489 9.31607 9.40426 9.91516 9.15364L14.392 7.2807C15.269 6.91375 15.8358 6.06239 15.8358 5.11166V3.91374C15.8358 2.61727 14.781 1.56252 13.4845 1.56252H4.51527V1.56248ZM12.7108 5.74212V3.78902C12.6695 2.75247 11.1892 2.75325 11.1483 3.78902V5.74212C11.1483 6.1736 11.4981 6.52336 11.9296 6.52336C12.361 6.52336 12.7108 6.1736 12.7108 5.74212ZM6.85149 5.74212V3.78902C6.81024 2.75247 5.32991 2.75325 5.28901 3.78902V5.74212C5.28901 6.1736 5.63877 6.52336 6.07025 6.52336C6.50173 6.52336 6.85149 6.1736 6.85149 5.74212ZM9.8202 5.78118V3.82808C9.77895 2.79153 8.29862 2.79231 8.25772 3.82808V5.78118C8.25772 6.21266 8.60748 6.56242 9.03896 6.56242C9.47044 6.56242 9.8202 6.21266 9.8202 5.78118ZM7.39121 19.9998C6.45708 20.015 5.68088 19.1145 5.86099 18.1871L6.0363 17.1732L5.29264 16.4539C4.36652 15.574 4.88862 13.9805 6.15279 13.8108L7.18551 13.6619L7.64621 12.7357C8.20112 11.5937 9.87704 11.5941 10.4317 12.7357L10.8924 13.6619L11.9251 13.8109C13.1897 13.9807 13.7111 15.5743 12.7852 16.454L12.0416 17.1732L12.2169 18.1871C12.3176 18.7699 12.0828 19.3491 11.604 19.6986C11.1219 20.0504 10.4936 20.0975 9.96407 19.8214L9.03736 19.338L8.11386 19.8214C7.88488 19.9408 7.63738 19.9998 7.39121 19.9998ZM6.40255 15.3535L7.12863 16.0559C7.49687 16.412 7.66476 16.9254 7.57769 17.4294L7.40488 18.4289L8.31792 17.9527C8.7694 17.7171 9.30849 17.7171 9.76005 17.9527L10.673 18.4288L10.5002 17.4294C10.4132 16.9254 10.5811 16.412 10.9493 16.0558L11.6755 15.3535L10.6661 15.2079C10.1604 15.1351 9.7229 14.8192 9.49603 14.3631L9.03896 13.4442L8.5819 14.3631C8.35499 14.8192 7.91757 15.1351 7.41179 15.2079L6.40255 15.3535Z"-->
            <!--                  ></path>-->
            <!--                </svg>-->
            <!--                <span>Bet Builder</span>-->
            <!--              </button>-->
            <!--            </div>-->

            <div v-show="showFreebet" class="overlay-menu-nav-item">
              <button
                aria-pressed="true"
                aria-describedby="a11y__link-button--casino"
                aria-label="Crash Games icon"
                class="overlay-menu__nav__button"
                @click="goToBetFreeb"
              >
                <svg
                  width="20px"
                  height="20px"
                  viewBox="0 0 192 192"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <g style="stroke-width: 0.903553">
                      <g style="stroke-width: 1.22576">
                        <path
                          d="M6 104V56h34.856M6 80h21.855"
                          class="a"
                          style="
                            fill: none;
                            stroke: var(--color-fg);
                            stroke-width: 14.7089;
                            stroke-linecap: round;
                            stroke-linejoin: round;
                            stroke-dasharray: none;
                          "
                          transform="matrix(.79792 0 0 .83414 17.08 29.264)"
                        ></path>
                      </g>
                      <g style="stroke-width: 2.24031; stroke-dasharray: none">
                        <path
                          d="M14.665 15.027V7.109h2.574a2.672 2.672 0 1 1 0 5.345h-2.574m5.245 2.573-2.483-2.582"
                          class="a"
                          style="
                            fill: none;
                            stroke: var(--color-fg);
                            stroke-width: 2.24031;
                            stroke-linecap: round;
                            stroke-linejoin: round;
                            stroke-dasharray: none;
                          "
                          transform="matrix(5.56244 0 0 5.15795 -16.54 38.912)"
                        ></path>
                      </g>
                      <g style="stroke-width: 1.03392">
                        <path
                          d="M6 6h28v0M6 24h28v0M6 42h28v0"
                          style="
                            fill: none;
                            stroke: var(--color-fg);
                            stroke-width: 12.4073;
                            stroke-linecap: round;
                            stroke-linejoin: round;
                            stroke-miterlimit: 1;
                            stroke-dasharray: none;
                            paint-order: stroke fill markers;
                          "
                          transform="matrix(.86732 0 0 1.07855 141.13 70.11)"
                        ></path>
                      </g>
                      <g style="stroke-width: 1.03392">
                        <path
                          d="M6 6h28v0M6 24h28v0M6 42h28v0"
                          style="
                            fill: none;
                            stroke: var(--color-fg);
                            stroke-width: 12.4073;
                            stroke-linecap: round;
                            stroke-linejoin: round;
                            stroke-miterlimit: 1;
                            stroke-dasharray: none;
                            paint-order: stroke fill markers;
                          "
                          transform="matrix(.86732 0 0 1.07855 103.848 70.12)"
                        ></path>
                      </g>
                    </g>
                  </g>
                </svg>
                <span>Freebet</span>
              </button>
            </div>

            <div class="overlay-menu-nav-item">
              <button
                aria-pressed="true"
                aria-describedby="a11y__link-button--live-games"
                aria-label="Live Games icon"
                class="overlay-menu__nav__button"
                @click="goToCH"
              >
                <svg
                  viewBox="0 0 18 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="overlay-menu__nav__icon"
                >
                  <path
                    d="M9.00811 10.8971C8.46182 10.8971 7.91597 10.7837 7.40961 10.5572L3.00587 8.72255C1.54491 8.11139 0.601562 6.69418 0.601562 5.11166V3.91374C0.601562 1.75568 2.35725 0 4.51527 0H13.4845C15.6425 0 17.3982 1.75568 17.3982 3.9137V5.11162C17.3982 6.69414 16.4549 8.11135 14.995 8.72208L10.5182 10.595C10.0365 10.7966 9.52212 10.8971 9.00811 10.8971ZM4.51527 1.56248C3.2188 1.56248 2.16404 2.61723 2.16404 3.9137V5.11162C2.16404 6.06235 2.73076 6.91375 3.60782 7.28066L8.02034 9.11896C8.0273 9.12185 8.03417 9.12485 8.04105 9.12794C8.63295 9.39489 9.31607 9.40426 9.91516 9.15364L14.392 7.2807C15.269 6.91375 15.8358 6.06239 15.8358 5.11166V3.91374C15.8358 2.61727 14.781 1.56252 13.4845 1.56252H4.51527V1.56248ZM12.7108 5.74212V3.78902C12.6695 2.75247 11.1892 2.75325 11.1483 3.78902V5.74212C11.1483 6.1736 11.4981 6.52336 11.9296 6.52336C12.361 6.52336 12.7108 6.1736 12.7108 5.74212ZM6.85149 5.74212V3.78902C6.81024 2.75247 5.32991 2.75325 5.28901 3.78902V5.74212C5.28901 6.1736 5.63877 6.52336 6.07025 6.52336C6.50173 6.52336 6.85149 6.1736 6.85149 5.74212ZM9.8202 5.78118V3.82808C9.77895 2.79153 8.29862 2.79231 8.25772 3.82808V5.78118C8.25772 6.21266 8.60748 6.56242 9.03896 6.56242C9.47044 6.56242 9.8202 6.21266 9.8202 5.78118ZM7.39121 19.9998C6.45708 20.015 5.68088 19.1145 5.86099 18.1871L6.0363 17.1732L5.29264 16.4539C4.36652 15.574 4.88862 13.9805 6.15279 13.8108L7.18551 13.6619L7.64621 12.7357C8.20112 11.5937 9.87704 11.5941 10.4317 12.7357L10.8924 13.6619L11.9251 13.8109C13.1897 13.9807 13.7111 15.5743 12.7852 16.454L12.0416 17.1732L12.2169 18.1871C12.3176 18.7699 12.0828 19.3491 11.604 19.6986C11.1219 20.0504 10.4936 20.0975 9.96407 19.8214L9.03736 19.338L8.11386 19.8214C7.88488 19.9408 7.63738 19.9998 7.39121 19.9998ZM6.40255 15.3535L7.12863 16.0559C7.49687 16.412 7.66476 16.9254 7.57769 17.4294L7.40488 18.4289L8.31792 17.9527C8.7694 17.7171 9.30849 17.7171 9.76005 17.9527L10.673 18.4288L10.5002 17.4294C10.4132 16.9254 10.5811 16.412 10.9493 16.0558L11.6755 15.3535L10.6661 15.2079C10.1604 15.1351 9.7229 14.8192 9.49603 14.3631L9.03896 13.4442L8.5819 14.3631C8.35499 14.8192 7.91757 15.1351 7.41179 15.2079L6.40255 15.3535Z"
                  ></path>
                </svg>
                <span>Bet Hub</span>
                <span
                  style="
                    background-color: orangered;
                    color: white;
                    padding: 2px 8px;
                    border-radius: 12px;
                    font-size: 10px;
                    font-weight: bold;
                    margin-left: -12px;
                  "
                >
                  New
                </span>
              </button>
            </div>

            <div class="overlay-menu-nav-item">
              <button
                aria-pressed="true"
                aria-describedby="a11y__link-button--live-games"
                aria-label="Live Games icon"
                class="overlay-menu__nav__button"
                @click="goToSimulate"
              >
                <svg
                  id="Icons"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 32 32"
                  xml:space="preserve"
                  width="20px"
                  height="20px"
                  fill="var(--color-fg)"
                  stroke="var(--color-fg)"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <path
                      class="st0"
                      d="M4,23v5c0,1.1,0.9,2,2,2h5.2c0.5,0,1-0.2,1.4-0.6l2-2c0.8-0.8,2-0.8,2.8,0l2,2c0.4,0.4,0.9,0.6,1.4,0.6H26 c1.1,0,2-0.9,2-2v-5c0-1.1-0.9-2-2-2H6C4.9,21,4,21.9,4,23z"
                    ></path>
                    <path
                      class="st0"
                      d="M29,5c0-2.2-5.8-4-13-4S3,2.8,3,5s5.8,4,13,4V6l6,6l-6,6v-3c-7.2,0-13-1.8-13-4V5"
                    ></path>
                  </g>
                </svg>
                <span>Simulate Bets</span>
                <span
                  style="
                    background-color: orangered;
                    color: white;
                    padding: 2px 8px;
                    border-radius: 12px;
                    font-size: 10px;
                    font-weight: bold;
                    margin-left: -12px;
                  "
                >
                  New
                </span>
              </button>
            </div>

            <div class="overlay-menu-nav-item d-none">
              <button
                aria-pressed="true"
                aria-describedby="a11y__link-button--shikisha-bet"
                aria-label="Shikisha Bet icon"
                class="overlay-menu__nav__button"
                @click="goToSambaza"
              >
                <svg
                  width="20px"
                  height="20px"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <path
                      d="M13.3085 0.293087C13.699 -0.0976958 14.3322 -0.0976956 14.7227 0.293087L17.7186 3.29095C18.1091 3.68175 18.1091 4.31536 17.7185 4.70613L14.716 7.71034C14.3255 8.10113 13.6923 8.10113 13.3018 7.71034C12.9113 7.31956 12.9113 6.68598 13.3018 6.2952L14.6087 4.98743L7 4.98743C6.44771 4.98743 6 4.53942 6 3.98677C6 3.43412 6.44771 2.98611 7 2.98611L14.5855 2.9861L13.3085 1.70824C12.918 1.31745 12.918 0.683869 13.3085 0.293087Z"
                      fill="#ffffff"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M12 20.998C14.2091 20.998 16 19.206 16 16.9954C16 14.7848 14.2091 12.9927 12 12.9927C9.79086 12.9927 8 14.7848 8 16.9954C8 19.206 9.79086 20.998 12 20.998ZM12 19.0934C10.842 19.0934 9.90331 18.1541 9.90331 16.9954C9.90331 15.8366 10.842 14.8973 12 14.8973C13.158 14.8973 14.0967 15.8366 14.0967 16.9954C14.0967 18.1541 13.158 19.0934 12 19.0934Z"
                      fill="#ffffff"
                    ></path>
                    <path
                      d="M7 16.9954C7 17.548 6.55229 17.996 6 17.996C5.44772 17.996 5 17.548 5 16.9954C5 16.4427 5.44772 15.9947 6 15.9947C6.55229 15.9947 7 16.4427 7 16.9954Z"
                      fill="#ffffff"
                    ></path>
                    <path
                      d="M19 16.9954C19 17.548 18.5523 17.996 18 17.996C17.4477 17.996 17 17.548 17 16.9954C17 16.4427 17.4477 15.9947 18 15.9947C18.5523 15.9947 19 16.4427 19 16.9954Z"
                      fill="#ffffff"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M21 9.99074C22.6569 9.99074 24 11.3348 24 12.9927V20.998C24 22.656 22.6569 24 21 24H3C1.34315 24 0 22.656 0 20.998V12.9927C0 11.3348 1.34315 9.99074 3 9.99074H21ZM4 11.9921H20C20 12.2549 20.0517 12.5151 20.1522 12.7579C20.2528 13.0007 20.4001 13.2214 20.5858 13.4072C20.7715 13.593 20.992 13.7405 21.2346 13.841C21.4773 13.9416 21.7374 13.9934 22 13.9934V19.9974C21.7374 19.9974 21.4773 20.0491 21.2346 20.1497C20.992 20.2503 20.7715 20.3977 20.5858 20.5835C20.4001 20.7694 20.2528 20.99 20.1522 21.2328C20.0517 21.4756 20 21.7359 20 21.9987H4C4 21.7359 3.94827 21.4756 3.84776 21.2328C3.74725 20.99 3.59993 20.7694 3.41421 20.5835C3.2285 20.3977 3.00802 20.2503 2.76537 20.1497C2.52272 20.0491 2.26264 19.9974 2 19.9974V13.9934C2.26264 13.9934 2.52272 13.9416 2.76537 13.841C3.00802 13.7405 3.2285 13.593 3.41421 13.4072C3.59993 13.2214 3.74725 13.0007 3.84776 12.7579C3.94827 12.5151 4 12.2549 4 11.9921Z"
                      fill="var(--color-fg)"
                    ></path>
                  </g>
                </svg>
                <span>Sambaza Stake</span>
                <span
                  style="
                    background-color: yellow;
                    color: black;
                    padding: 2px 8px;
                    border-radius: 12px;
                    font-size: 10px;
                    font-weight: bold;
                    margin-left: -12px;
                  "
                >
                  Exclusive
                </span>
              </button>
            </div>

            <div class="overlay-menu-nav-item">
              <button
                aria-pressed="true"
                aria-describedby="a11y__link-button--shikisha-bet"
                aria-label="Shikisha Bet icon"
                class="overlay-menu__nav__button"
                @click="goToLoad"
              >
                <svg
                  width="20px"
                  height="20px"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.9436 1.25H13.0564C14.8942 1.24998 16.3498 1.24997 17.489 1.40314C18.6614 1.56076 19.6104 1.89288 20.3588 2.64124C20.6516 2.93414 20.6516 3.40901 20.3588 3.7019C20.0659 3.9948 19.591 3.9948 19.2981 3.7019C18.8749 3.27869 18.2952 3.02502 17.2892 2.88976C16.2615 2.75159 14.9068 2.75 13 2.75H11C9.09318 2.75 7.73851 2.75159 6.71085 2.88976C5.70476 3.02502 5.12511 3.27869 4.7019 3.7019C4.27869 4.12511 4.02502 4.70476 3.88976 5.71085C3.75159 6.73851 3.75 8.09318 3.75 10V14C3.75 15.9068 3.75159 17.2615 3.88976 18.2892C4.02502 19.2952 4.27869 19.8749 4.7019 20.2981C5.12511 20.7213 5.70476 20.975 6.71085 21.1102C7.73851 21.2484 9.09318 21.25 11 21.25H13C14.9068 21.25 16.2615 21.2484 17.2892 21.1102C18.2952 20.975 18.8749 20.7213 19.2981 20.2981C19.994 19.6022 20.2048 18.5208 20.2414 15.9892C20.2474 15.575 20.588 15.2441 21.0022 15.2501C21.4163 15.2561 21.7472 15.5967 21.7412 16.0108C21.7061 18.4383 21.549 20.1685 20.3588 21.3588C19.6104 22.1071 18.6614 22.4392 17.489 22.5969C16.3498 22.75 14.8942 22.75 13.0564 22.75H10.9436C9.10583 22.75 7.65019 22.75 6.51098 22.5969C5.33856 22.4392 4.38961 22.1071 3.64124 21.3588C2.89288 20.6104 2.56076 19.6614 2.40314 18.489C2.24997 17.3498 2.24998 15.8942 2.25 14.0564V9.94358C2.24998 8.10582 2.24997 6.65019 2.40314 5.51098C2.56076 4.33856 2.89288 3.38961 3.64124 2.64124C4.38961 1.89288 5.33856 1.56076 6.51098 1.40314C7.65019 1.24997 9.10582 1.24998 10.9436 1.25ZM18.1131 7.04556C19.1739 5.98481 20.8937 5.98481 21.9544 7.04556C23.0152 8.1063 23.0152 9.82611 21.9544 10.8869L17.1991 15.6422C16.9404 15.901 16.7654 16.076 16.5693 16.2289C16.3387 16.4088 16.0892 16.563 15.8252 16.6889C15.6007 16.7958 15.3659 16.8741 15.0187 16.9897L12.9351 17.6843C12.4751 17.8376 11.9679 17.7179 11.625 17.375C11.2821 17.0321 11.1624 16.5249 11.3157 16.0649L11.9963 14.0232C12.001 14.0091 12.0056 13.9951 12.0102 13.9813C12.1259 13.6342 12.2042 13.3993 12.3111 13.1748C12.437 12.9108 12.5912 12.6613 12.7711 12.4307C12.924 12.2346 13.099 12.0596 13.3578 11.8009C13.3681 11.7906 13.3785 11.7802 13.3891 11.7696L18.1131 7.04556ZM20.8938 8.10622C20.4188 7.63126 19.6488 7.63126 19.1738 8.10622L18.992 8.288C19.0019 8.32149 19.0132 8.3571 19.0262 8.39452C19.1202 8.66565 19.2988 9.02427 19.6372 9.36276C19.9757 9.70125 20.3343 9.87975 20.6055 9.97382C20.6429 9.9868 20.6785 9.99812 20.712 10.008L20.8938 9.8262C21.3687 9.35124 21.3687 8.58118 20.8938 8.10622ZM19.5664 11.1536C19.2485 10.9866 18.9053 10.7521 18.5766 10.4234C18.2479 10.0947 18.0134 9.75146 17.8464 9.43357L14.4497 12.8303C14.1487 13.1314 14.043 13.2388 13.9538 13.3532C13.841 13.4979 13.7442 13.6545 13.6652 13.8202C13.6028 13.9511 13.5539 14.0936 13.4193 14.4976L13.019 15.6985L13.3015 15.981L14.5024 15.5807C14.9064 15.4461 15.0489 15.3972 15.1798 15.3348C15.3455 15.2558 15.5021 15.159 15.6468 15.0462C15.7612 14.957 15.8686 14.8513 16.1697 14.5503L19.5664 11.1536ZM7.25 9C7.25 8.58579 7.58579 8.25 8 8.25H14.5C14.9142 8.25 15.25 8.58579 15.25 9C15.25 9.41421 14.9142 9.75 14.5 9.75H8C7.58579 9.75 7.25 9.41421 7.25 9ZM7.25 13C7.25 12.5858 7.58579 12.25 8 12.25H10.5C10.9142 12.25 11.25 12.5858 11.25 13C11.25 13.4142 10.9142 13.75 10.5 13.75H8C7.58579 13.75 7.25 13.4142 7.25 13ZM7.25 17C7.25 16.5858 7.58579 16.25 8 16.25H9.5C9.91421 16.25 10.25 16.5858 10.25 17C10.25 17.4142 9.91421 17.75 9.5 17.75H8C7.58579 17.75 7.25 17.4142 7.25 17Z"
                      fill="var(--color-fg)"
                    ></path>
                  </g>
                </svg>
                <span>Load Code</span>
              </button>
            </div>

            <div class="overlay-menu-nav-item">
              <button
                aria-pressed="true"
                aria-describedby="a11y__link-button--shikisha-bet"
                aria-label="Shikisha Bet icon"
                class="overlay-menu__nav__button"
                @click="goToApp"
              >
                <svg
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="overlay-menu__nav__icon"
                >
                  <path
                    d="M12.3438 20H7.65625C5.50234 20 3.75 18.2477 3.75 16.0938V3.90625C3.75 1.75234 5.50234 0 7.65625 0H12.3438C14.4977 0 16.25 1.75234 16.25 3.90625V16.0938C16.25 18.2477 14.4977 20 12.3438 20ZM7.65625 1.5625C6.36391 1.5625 5.3125 2.61391 5.3125 3.90625V16.0938C5.3125 17.3861 6.36391 18.4375 7.65625 18.4375H12.3438C13.6361 18.4375 14.6875 17.3861 14.6875 16.0938V3.90625C14.6875 2.61391 13.6361 1.5625 12.3438 1.5625H7.65625Z"
                  ></path>
                  <path
                    d="M10.7812 16.875H9.21875C8.78727 16.875 8.4375 16.5252 8.4375 16.0938C8.4375 15.6623 8.78727 15.3125 9.21875 15.3125H10.7812C11.2127 15.3125 11.5625 15.6623 11.5625 16.0938C11.5625 16.5252 11.2127 16.875 10.7812 16.875Z"
                  ></path>
                  <path
                    d="M10.7812 4.6875H9.21875C8.78727 4.6875 8.4375 4.33773 8.4375 3.90625C8.4375 3.47477 8.78727 3.125 9.21875 3.125H10.7812C11.2127 3.125 11.5625 3.47477 11.5625 3.90625C11.5625 4.33773 11.2127 4.6875 10.7812 4.6875Z"
                  ></path>
                </svg>
                <span>Download App</span>
              </button>
            </div>

            <div class="overlay-menu-nav-item">
              <button
                aria-pressed="true"
                aria-describedby="a11y__link-button--offers-rewards"
                aria-label="Promotions icon"
                class="overlay-menu__nav__button"
                @click="goToLead"
              >
                <svg
                  width="20px"
                  height="20px"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <path
                      d="M12.787 5.8071C13.0673 5.92318 13.25 6.19666 13.25 6.50001V10.5C13.25 10.9142 12.9142 11.25 12.5 11.25C12.0858 11.25 11.75 10.9142 11.75 10.5V8.31067L11.5303 8.53034C11.2374 8.82323 10.7626 8.82323 10.4697 8.53034C10.1768 8.23744 10.1768 7.76257 10.4697 7.46968L11.9697 5.96968C12.1842 5.75518 12.5068 5.69101 12.787 5.8071Z"
                      fill="#1C274C"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.4984 1.60719C8.66129 1.41099 10.1724 1.25 12.0002 1.25C13.8279 1.25 15.339 1.41099 16.5019 1.60719L16.6368 1.62983C17.647 1.79893 18.4866 1.93949 19.1432 2.74808C19.5643 3.26668 19.7001 3.82713 19.7314 4.45323L20.2231 4.61712C20.6862 4.77147 21.0921 4.90675 21.4142 5.05656C21.7623 5.21852 22.0814 5.42714 22.3253 5.76555C22.5692 6.10396 22.6662 6.47262 22.7097 6.85411C22.75 7.20701 22.75 7.63488 22.7499 8.12306L22.7499 8.26828C22.7499 8.67007 22.75 9.02499 22.7203 9.32179C22.6881 9.64348 22.6169 9.95621 22.4391 10.2584C22.2613 10.5607 22.0225 10.7748 21.7569 10.9591C21.5118 11.1292 21.2016 11.3015 20.8503 11.4966L18.2097 12.9637C17.6703 14.025 16.9292 14.9713 15.9101 15.6548C15.0354 16.2414 13.9881 16.6128 12.75 16.7187V18.75H14.1802C15.0144 18.75 15.7326 19.3388 15.8962 20.1568L16.1149 21.25H18C18.4142 21.25 18.75 21.5858 18.75 22C18.75 22.4142 18.4142 22.75 18 22.75H6C5.58579 22.75 5.25 22.4142 5.25 22C5.25 21.5858 5.58579 21.25 6 21.25H7.88515L8.10379 20.1568C8.26739 19.3388 8.98562 18.75 9.81981 18.75H11.25V16.7187C10.012 16.6127 8.9648 16.2414 8.09017 15.6548C7.07115 14.9713 6.33018 14.0252 5.79078 12.964L3.14962 11.4966C2.79836 11.3015 2.48813 11.1292 2.24307 10.9591C1.97748 10.7748 1.73867 10.5607 1.56083 10.2584C1.38299 9.95621 1.3118 9.64348 1.27965 9.32179C1.24999 9.02497 1.25 8.67008 1.25001 8.26827L1.25 8.12304C1.24996 7.63488 1.24992 7.20701 1.2902 6.85411C1.33375 6.47262 1.43076 6.10396 1.67466 5.76555C1.91857 5.42714 2.23762 5.21852 2.58577 5.05656C2.90781 4.90675 3.31373 4.77147 3.77686 4.61712L4.26891 4.4531C4.30023 3.82706 4.43608 3.26664 4.85712 2.74808C5.51366 1.93949 6.35333 1.79893 7.36355 1.62983L7.4984 1.60719ZM9.41486 21.25H14.5852L14.4253 20.451C14.402 20.3341 14.2994 20.25 14.1802 20.25H9.81981C9.70064 20.25 9.59804 20.3341 9.57467 20.451L9.41486 21.25ZM4.3021 6.02318C4.37367 7.54348 4.5454 9.22376 4.97298 10.7937L3.90729 10.2016C3.51814 9.98542 3.27447 9.84906 3.09829 9.72679C2.93588 9.61407 2.88298 9.54762 2.85363 9.49774C2.82428 9.44786 2.79187 9.36934 2.77221 9.17263C2.75089 8.95925 2.75002 8.68002 2.75001 8.23484L2.75001 8.16231C2.74999 7.62323 2.75111 7.28191 2.78053 7.02422C2.80775 6.7857 2.85231 6.69703 2.89154 6.6426C2.93077 6.58817 3.0008 6.51786 3.21847 6.4166C3.45362 6.3072 3.77708 6.19819 4.28849 6.02772L4.3021 6.02318ZM19.0274 10.7934L20.0927 10.2016C20.4818 9.98542 20.7255 9.84906 20.9016 9.72679C21.0641 9.61407 21.117 9.54762 21.1463 9.49774C21.1757 9.44786 21.2081 9.36934 21.2277 9.17263C21.2491 8.95925 21.2499 8.68002 21.2499 8.23484L21.2499 8.16231C21.25 7.62323 21.2488 7.28191 21.2194 7.02422C21.1922 6.7857 21.1476 6.69703 21.1084 6.6426C21.0692 6.58817 20.9991 6.51786 20.7815 6.4166C20.5463 6.3072 20.2229 6.19819 19.7115 6.02772L19.6982 6.0233C19.6266 7.54349 19.4549 9.22363 19.0274 10.7934ZM12.0002 2.75C10.2608 2.75 8.83319 2.90319 7.74796 3.08629C6.54104 3.28992 6.28751 3.3661 6.02161 3.69358C5.75956 4.01632 5.73468 4.32156 5.78848 5.67672C5.87815 7.93537 6.1761 10.3727 7.09884 12.2264C7.55432 13.1414 8.14983 13.8887 8.92569 14.409C9.69656 14.9261 10.6911 15.25 12.0002 15.25C13.3092 15.25 14.3037 14.9261 15.0746 14.409C15.8505 13.8887 16.446 13.1414 16.9015 12.2264C17.8242 10.3727 18.1222 7.93537 18.2118 5.67672C18.2656 4.32156 18.2407 4.01632 17.9787 3.69358C17.7128 3.3661 17.4593 3.28992 16.2524 3.08629C15.1671 2.90319 13.7395 2.75 12.0002 2.75Z"
                      fill="var(--color-fg)"
                    ></path>
                  </g>
                </svg>
                <span>Referrals</span>
                <span
                  style="
                    background-color: orangered;
                    color: white;
                    padding: 2px 8px;
                    border-radius: 12px;
                    font-size: 10px;
                    font-weight: bold;
                    margin-left: -12px;
                  "
                >
                  New
                </span>
              </button>
            </div>

            <div class="overlay-menu-nav-item">
              <button
                aria-pressed="true"
                aria-describedby="a11y__link-button--offers-rewards"
                aria-label="Promotions icon"
                class="overlay-menu__nav__button"
                @click="goToPromo"
              >
                <svg
                  width="22px"
                  height="22px"
                  viewBox="0 0 64 64"
                  xmlns="http://www.w3.org/2000/svg"
                  stroke-width="3"
                  stroke="var(--color-fg)"
                  fill="none"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <path
                      d="M32.94,57.93H10.41a3.07,3.07,0,0,1-3.07-3.06V9.13a3.07,3.07,0,0,1,3.07-3.06H31.62a3.07,3.07,0,0,1,3.07,3.06l-.12,9.34.08,16.26,0,4.42"
                    ></path>
                    <line x1="16.02" y1="10.34" x2="22.1" y2="10.34" stroke-linecap="round"></line>
                    <line x1="19.49" y1="53.47" x2="22.54" y2="53.47" stroke-linecap="round"></line>
                    <line x1="25.88" y1="10.34" x2="26.01" y2="10.34" stroke-linecap="round"></line>
                    <line x1="7.34" y1="49.36" x2="33.88" y2="49.36"></line>
                    <line x1="7.34" y1="14.75" x2="34.69" y2="14.75"></line>
                    <path
                      d="M56.57,57.93H32.94l.81-14.74a10.64,10.64,0,0,1,10.62-10h1.25a10.13,10.13,0,0,1,10.11,9.56Z"
                    ></path>
                    <path
                      d="M41.94,33.56l-4.22-8a.27.27,0,0,1,.29-.4l2.55.42a25.2,25.2,0,0,0,8.13,0l2.81-.45a.27.27,0,0,1,.28.41l-4.63,7.77"
                    ></path>
                    <line x1="44.75" y1="29.92" x2="44.19" y2="33.15" stroke-linecap="round"></line>
                    <path
                      d="M49.53,41.21a4.62,4.62,0,0,0-4.34-2.81c-3.91,0-4.06,2.81-4.06,2.81s-.59,3.45,4.2,3.82c5,.38,4.2,3.82,4.2,3.82A4.16,4.16,0,0,1,45.33,52c-3.69.19-4.84-3.69-4.84-3.69"
                    ></path>
                    <line x1="45.19" y1="35.92" x2="45.19" y2="54.9"></line>
                  </g>
                </svg>
                <span>Promotions</span>
                <span
                  style="
                    background-color: orangered;
                    color: white;
                    padding: 2px 8px;
                    border-radius: 12px;
                    font-size: 10px;
                    font-weight: bold;
                    margin-left: -12px;
                  "
                >
                  New
                </span>
              </button>
            </div>

            <div class="overlay-menu-nav-item">
              <button
                aria-pressed="true"
                aria-describedby="a11y__link-button--offers-rewards"
                aria-label="Promotions icon"
                class="overlay-menu__nav__button"
                @click="goToPrint"
              >
                <svg
                  id="Capa_1"
                  fill="var(--color-fg)"
                  height="22px"
                  width="22px"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 612.001 612.001"
                  xml:space="preserve"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <g>
                      <g>
                        <g>
                          <path
                            d="M542.423,213.376h-57.535V32.386c0-9.448-7.659-17.108-17.108-17.108H144.22c-9.449,0-17.108,7.66-17.108,17.108v180.99 H69.579C31.212,213.376,0,244.588,0,282.955v183.955c0,38.364,31.212,69.576,69.579,69.576h54.233v43.129 c0,9.448,7.659,17.108,17.108,17.108h330.163c9.449,0,17.108-7.66,17.108-17.108v-43.13h54.233 c38.366,0,69.579-31.212,69.579-69.576V282.955C612,244.588,580.788,213.376,542.423,213.376z M577.784,466.911 c0,19.497-15.863,35.36-35.363,35.36h-54.233V362.875c0-9.449-7.659-17.108-17.108-17.108H140.919 c-9.449,0-17.108,7.659-17.108,17.108v139.395H69.579c-19.5-0.001-35.363-15.863-35.363-35.36V328.52h543.569V466.911z M161.328,49.494h289.345v163.882H161.328V49.494z M34.216,282.955c0-19.499,15.863-35.363,35.363-35.363h472.844 c19.5,0,35.363,15.863,35.363,35.363v11.35H34.216V282.955z M453.974,562.507H158.027V379.982h295.947V562.507z"
                          ></path>
                          <path
                            d="M535.533,253.839c-4.505,0-8.91,1.825-12.104,5.018c-3.179,3.179-5.004,7.584-5.004,12.089s1.825,8.91,5.004,12.104 c3.193,3.179,7.599,5.004,12.104,5.004c4.491,0,8.91-1.825,12.089-5.004c3.193-3.193,5.018-7.599,5.018-12.104 s-1.823-8.91-5.018-12.089C544.443,255.664,540.025,253.839,535.533,253.839z"
                          ></path>
                          <path
                            d="M202.439,451.799h200.323c9.448,0,17.108-7.66,17.108-17.108c0-9.449-7.66-17.108-17.108-17.108H202.439 c-9.448,0-17.108,7.659-17.108,17.108C185.331,444.14,192.991,451.799,202.439,451.799z"
                          ></path>
                          <path
                            d="M202.439,524.907h93.581c9.449,0,17.108-7.66,17.108-17.108c0-9.448-7.659-17.108-17.108-17.108h-93.581 c-9.448,0-17.108,7.66-17.108,17.108C185.331,517.249,192.991,524.907,202.439,524.907z"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
                <span>Print Games</span>
              </button>
            </div>
          </div>
        </div>

        <div class="games-menu players-menu-account">
          <div class="modevisible">
            <div class="display-text">
              <h4>Display</h4>
              <p>Switch between light theme and dark theme</p>
            </div>
            <button type="button" aria-label="toggle theme" @click="$toggleTheme">
              <i class="fa fa-adjust" aria-hidden="true"></i>
            </button>
          </div>
        </div>

        <div class="games-menu players-menu-account">
          <h4>Players Account</h4>
          <a href="#" style="cursor: pointer" @click.prevent="goToAcc"
            ><span class="menu-item"
              ><i class="bi bi-person-circle"></i> &nbsp;&nbsp;my account</span
            ></a
          >
          <a href="#" style="cursor: pointer" @click.prevent="goTobh">
            <span class="menu-item"><i class="bi bi-receipt"></i> &nbsp;&nbsp;bet history</span>
          </a>
          <a href="#" style="cursor: pointer" @click.prevent="goToRefer">
            <span class="menu-item"
              ><i class="bi bi-cash-coin"></i> &nbsp;&nbsp;refer and earn</span
            ></a
          >
        </div>

        <div class="games-menu get-help">
          <h4>Get Help</h4>
          <a style="cursor: pointer" href="tel:0701001000">
            <span class="menu-item">Call Customer Support</span> <i class="bi bi-chevron-right"></i>
          </a>
          <a
            style="cursor: pointer"
            href="https://api.whatsapp.com/send/?phone=254704498098"
            target="_blank"
          >
            <span class="menu-item">Whatsapp Chat</span> <i class="bi bi-chevron-right"></i>
          </a>
          <a href="#" style="cursor: pointer" @click.prevent="goToHelp">
            <span class="menu-item">Help centre</span> <i class="bi bi-chevron-right"></i>
          </a>
        </div>

        <div class="games-menu about">
          <h4>Maybets Hub</h4>
          <a href="#" style="cursor: pointer" target="_blank" @click.prevent="goToPrintGames">
            <span class="menu-item">Print Games</span>
          </a>
          <a href="#" style="cursor: pointer" target="_blank" @click.prevent="goToLivescore">
            <span class="menu-item">Live Score</span>
          </a>
          <a
            href="#"
            style="
              cursor: pointer;
              border-bottom: 1px solid var(--border-bg-color);
              padding-bottom: 10px;
            "
            @click.prevent="goToPromo"
          >
            <span class="menu-item">News</span>
          </a>
          <a href="#" style="padding-top: 5px" @click.prevent="goToFaqs">
            <span class="menu-item">FAQs</span><i class="bi bi-chevron-right"></i>
          </a>
          <a href="#" style="cursor: pointer" @click.prevent="goToTerms">
            <span class="menu-item">terms and conditions</span> <i class="bi bi-chevron-right"></i>
          </a>
          <a href="#" @click.prevent="goToResp">
            <span class="menu-item">responsible gambling</span><i class="bi bi-chevron-right"></i>
          </a>
        </div>

        <div class="games-menu get-help" style="cursor: pointer" @click.prevent="logout">
          <h4>Logout</h4>
          <a href="#" style="cursor: pointer" @click.prevent="logout">
            <span class="menu-item pb-2">You can always login again anytime</span></a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { useAuthStore } from '@/stores/auth.js'
import fix from '@/services/fix.js'
import { useSportStore } from '@/stores/sport.js'
import { useMenuStore } from '@/stores/menu.js'

export default {
  emits: ['close'],
  data() {
    return {
      tournaments: [],
      cacheKey: 0,
      currentTheme: document.documentElement.getAttribute('data-theme')
    }
  },
  computed: {
    logoSrc() {
      return this.currentTheme === 'light'
        ? '/assets/images/backup/maybetslogo.png'
        : '/assets/images/maybetslight.webp'
    },
    isOpen() {
      return this.handleNav !== null && typeof this.handleNav === 'function'
    },
    filterTournaments() {
      return this.tournaments.slice(0, 6)
    },
    filterCountries() {
      const allowedIds = this.filterTournaments.map((tournament) => tournament.tournament_id)
      const seenCategories = new Set()

      return this.tournaments
        .filter(
          (tournament) =>
            !allowedIds.includes(tournament.tournament_id) &&
            tournament.games > 1 &&
            !seenCategories.has(tournament.category_name) &&
            seenCategories.add(tournament.category_name)
        )
        .slice(0, 30) // Get the first 20 items
    },
    sportId() {
      const sportStore = useSportStore()
      return sportStore.getSportId
    },
    showFreebet() {
      let authStore = useAuthStore()
      if (authStore.user && authStore.user.date_created) {
        const dateCreated = new Date(authStore.user.date_created)
        const now = new Date()
        const hoursDifference = (now - dateCreated) / 1000 / 60 / 60
        return hoursDifference <= 48
      }
      return false
    }
  },
  watch: {
    sportId: 'fetchData'
  },
  methods: {
    closeSideMenu() {
      const menuStore = useMenuStore()
      menuStore.closeSideMenu()
    },
    async fetchTournaments() {
      if (!this.tournaments || !this.tournaments.length || this.cacheKey !== this.sportId) {
        try {
          const url = `/tournaments/${this.sportId}`
          const response = await fix.get(url)
          this.tournaments = response.data
          this.cacheKey = this.sportId
        } catch (error) {
          console.error('Error fetching tournaments:', error)
        }
      }
    },
    sportIdRoute(sportId) {
      const sportStore = useSportStore()
      sportStore.updateSportId(sportId)
      this.closeSideMenu()
    },
    goToLnk() {
      window.location.href = 'https://responsiblegambling.or.ke'
      this.closeSideMenu()
    },
    goToCasino() {
      this.$router.push({ name: 'casino' })
      this.closeSideMenu()
    },
    goToLoad() {
      // this.$router.push({ name: 'betslip' });

      localStorage.removeItem('betslip')
      localStorage.removeItem('bSlip')
      this.$router.replace({ path: this.$route.path, query: {} })
      const menuStore = useMenuStore()
      menuStore.openBetslipModal()

      // // Show modal if it exists
      // const modalElement = document.getElementById('myBetSlip');
      // if (modalElement) {
      //   const statusSuccessModal = new bootstrap.Modal(modalElement);
      //   statusSuccessModal.show();
      // } else {
      //   console.warn("Modal element #myBetSlip not found.");
      // }
      this.closeSideMenu()
    },
    goHome() {
      this.$router.push({ name: 'home' })
      this.closeSideMenu()
    },
    goToLive() {
      this.$router.push({ name: 'live' })
      this.closeSideMenu()
    },
    goToLigi() {
      this.$router.push({ name: 'ligi' })
      this.closeSideMenu()
    },
    goToLivescore() {
      this.$router.push({ name: 'livescore' })
      this.closeSideMenu()
    },
    goToPrintGames() {
      this.$router.push({ name: 'print' })
      this.closeSideMenu()
    },
    goToCrash() {
      this.$router.push({ name: 'crashgames' })
      this.closeSideMenu()
    },
    goToAvi() {
      this.$router.push({ name: 'aviator' })
      this.closeSideMenu()
    },
    goToAviatorMiles() {
      this.$router.push({ name: 'aviator2' })
      this.closeSideMenu()
    },
    goToLead() {
      this.$router.push({ name: 'leaderboard' })
      this.closeSideMenu()
    },
    goToRefer() {
      this.$router.push({ name: 'referrals' })
      this.closeSideMenu()
    },
    goToPromo() {
      this.$router.push({ name: 'promos' })
      this.closeSideMenu()
    },
    goToPrint() {
      this.$router.push({ name: 'print' })
      this.closeSideMenu()
    },
    goToSambaza() {
      this.$router.push({ name: 'sambaza' })
      this.closeSideMenu()
    },
    goToSimulate() {
      this.$router.push({ path: 'promotions/maybets-simulated-bets' })
      this.closeSideMenu()
    },
    goToBetFreeb() {
      this.$router.push({ name: 'freebet' })
      this.closeSideMenu()
    },
    goToCH() {
      this.$router.push({ name: 'codehub' })
      this.closeSideMenu()
    },
    goToHelp() {
      this.$router.push({ name: 'help' })
      this.closeSideMenu()
    },
    goToAcc() {
      this.$router.push({ name: 'profile' })
      this.closeSideMenu()
    },
    goToApp() {
      this.$router.push({ name: 'app' })
      this.closeSideMenu()
    },
    goToFaqs() {
      this.$router.push({ name: 'faqs' })
      this.closeSideMenu()
    },
    goToTerms() {
      this.$router.push({ name: 'terms' })
      this.closeSideMenu()
    },
    goToResp() {
      this.$router.push({ name: 'responsible' })
      this.closeSideMenu()
    },
    goTobh() {
      this.$router.push({ name: 'bets' })
      this.closeSideMenu()
    },
    // goToJP() {
    //   this.$router.push({ name: 'jackpot' });
    //   this.closeSideMenu();
    // },
    goToCountries() {
      this.$router.push({ name: 'country-route' })
      this.closeSideMenu()
    },
    goToVirt() {
      this.$router.push({ name: 'virtualgames' })
      this.closeSideMenu()
    },
    goToPol() {
      this.$router.push({ name: 'responsible' })
      this.closeSideMenu()
    },
    logout() {
      const authStore = useAuthStore()
      authStore.logout()
      this.closeSideMenu()
    },
    isLoggedIn() {
      const authStore = useAuthStore()
      return authStore.user !== null
    },
    updateTheme() {
      this.currentTheme = document.documentElement.getAttribute('data-theme')
    },
    fetchData: _.debounce(function () {
      this.fetchTournaments()
    }, 300),
    selectCountry(tournamentId) {
      this.$router.push({ name: 'home', query: { tournamentId } })
      this.closeSideMenu()
    }
  },
  created() {
    window.addEventListener('themeChanged', this.updateTheme)
    this.fetchData()
  },
  beforeUnmount() {
    window.removeEventListener('themeChanged', this.updateTheme)
  }
}
</script>
